import useTypedTranslation, {
  type TFunctionType,
} from "@/core/hooks/use-typed-translation";

/**
 * Traductions des écrans admin (clés `admin.*` et `nav.admin.*`).
 *
 * Les clés vivent dans les fragments `features/admin/i18n/*.json`
 * et seront fusionnées dans `src/locales/*.json` lors du câblage final
 * par le coordinateur : tant que la fusion n'est pas faite,
 * `TFunctionType` (dérivé de fr.json) ne les connaît pas encore, d'où
 * le cast.
 */
export const useAdminTranslation = () => {
  const { t } = useTypedTranslation();
  return { t: (key: string) => t(key as TFunctionType) };
};
